export const holidaysList = [
  "2026-01-03",
  "2026-01-17",
  "2026-02-04",
  "2026-02-11",
  "2026-03-11",
  "2026-03-19",
  "2026-03-20",
  "2026-03-21",
  "2026-03-22",
  "2026-03-23",
  "2026-03-24",
  "2026-04-01",
  "2026-04-02",
  "2026-04-13",
  "2026-05-28",
  "2026-06-04",
  "2026-06-05",
  "2026-06-25",
  "2026-06-26",
  "2026-08-04",
  "2026-08-12",
  "2026-08-14",
  "2026-08-22",
  "2026-08-25",
  "2026-11-14",
  "2026-12-23",
  "2027-01-06",
  "2027-01-24",
  "2027-02-11",
  "2027-02-28",
  "2027-03-10",
  "2027-03-11",
  "2027-03-20",
  "2027-03-21",
  "2027-03-22",
  "2027-03-23",
  "2027-04-01",
  "2027-04-02",
  "2027-04-03",
  "2027-05-17",
  "2027-05-25",
  "2027-06-04",
  "2027-06-05",
  "2027-06-14",
  "2027-06-15",
  "2027-07-25",
  "2027-08-02",
  "2027-08-03",
  "2027-08-11",
  "2027-08-20",
  "2027-11-03",
  "2027-12-12",
  "2027-12-26"
];
